import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';

import { Observable } from 'rxjs';
import { mergeMap, map } from 'rxjs/operators';

@Component({
    selector: 'search-component',
    templateUrl: './search-component.component.html',
    styleUrls: ['./search-component.component.scss']
})
export class SearchComponentComponent implements OnInit {

    searchString: string = '';
    @Input() name: string = 'mainSearch';
    @Input() placeholder: string = 'Search...';
    @Input() displayProperty: string = '';
    @Input() isTypeahead: boolean = false;
    @Input() typeaheadFunction: Function;
    @Output() searchKeyword: EventEmitter<any> = new EventEmitter<any>();


    // TypeAhead
    @Input() asyncSelected: string; // you can use it, if you need to append 
    typeaheadLoading: boolean;
    noResult: boolean = false;
    dataSource: Observable<any>;
    constructor() {
        this.dataSource = Observable.create((observer: any) => {
            // Runs on every search
            observer.next(this.asyncSelected);
        }).pipe(mergeMap((token: string) => this.getStatesAsObservable(token)));
    }


    ngOnInit() {
    }

    getStatesAsObservable(token: string): Observable<any> {
        if (!this.isTypeahead) {
            return Observable.of([]);
        }

        return this.typeaheadFunction(token);
    }

    searchByKeyword() {
        this.searchKeyword.emit(this.asyncSelected);
    }

    changeTypeaheadLoading(e: boolean): void {
        this.typeaheadLoading = e;
    }

    typeaheadNoResults(event: boolean): void {
        this.noResult = event;
    }

    typeaheadOnSelect(e: TypeaheadMatch): void {
        this.searchKeyword.emit(e.item)
    }
}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/searchComponent/search-component.component.ts